<template>
  <div class="context common_table_view" ref="common_table_view">
    <div class="header" ref="header">
      <div class="search">
        <!-- <div class="search_item" style="justify-content: space-between">
          <div class="input_box">
            <el-input
              v-model="searchForm.input"
              placeholder="请输入姓名或完整手机号"
              class="width_400"
              @change="getTableData()"
              size="small"
              clearable
            ></el-input>
            <span style="padding-left: 10px">
              <el-button type="primary" size="small" @click="getTableData()"
                >搜索</el-button
              >
            </span>
          </div>
        </div> -->
        <!-- <div class="search_item">
          <div class="title has_title">状态：</div>
          <div class="input_box">
            <div
              v-for="(item, index) in status_list"
              :key="index"
              :class="searchForm.status === item.value ? 'actived_btn' : ''"
              @click="changeCell(item.value, 'status')"
              class="btn"
            >
              {{ item.name }}
            </div>
          </div>
        </div> -->
      </div>
    </div>
    <div class="table">
      <el-table
        :data="tableData"
        ref="table"
        stripe
        @row-dblclick="goToAudit"
        width="100%"
        :height="tableHeight"
      >
        <el-table-column
          type="index"
          fixed="left"
          width="65"
          label="序号"
        ></el-table-column>
        <el-table-column
          v-for="(item, index) in columnData"
          :prop="item.prop"
          :label="item.label"
          :width="item.width"
          :formatter="item.formatter"
          :fixed="item.fixed"
          show-overflow-tooltip
          :key="index"
        ></el-table-column>
      </el-table>
    </div>
    <div class="bottom_page" ref="bottom_page">
      <page-view
        @getTableList="handleCurrentChange"
        :currentPage="currentPage"
        :pageSize="pageSize"
        :total="total"
      ></page-view>
    </div>
  </div>
</template>
<script>
import { mapMutations } from "vuex";
export default {
  data() {
    const showPhone = (row, column, cellValue, index) => {
      let text = row.patient_data.user_id == cellValue ? "" : cellValue;
      if (text) {
        text = text.replace(text.substring(3, 7), "****");
      }
      return text;
    };
    const showStatus = (row, column, cellValue, index) => {
      let text = "";
      if (cellValue == 1) {
        text = "未完成";
      } else if (cellValue == 2) {
        text = "已完成";
      }
      return text;
    };
    const showPatientName = (row, column, cellValue, index) => {
      if (cellValue.length <= 2) {
        cellValue = cellValue.split("");
        cellValue.splice(1, 0, "*");
        cellValue = cellValue.join("");
      }
      if (cellValue) {
        cellValue = cellValue.replace(cellValue.substring(1, 2), "*");
      }
      return cellValue;
    };
    return {
      tableHeight: 0,
      currentPage: 1,
      pageSize: 50,
      total: 0,
      tableData: [],
      searchForm: {
        status: "",
      },
      columnData: [
        {
          label: "患者名称",
          prop: "patient_data.patient_name",
          formatter: showPatientName,
        },
        {
          label: "手机号",
          prop: "patient_data.patient_phone",
          formatter: showPhone,
        },
        // { label: "使用药物", prop: "task_data.drug_code_str" },
        { label: "癌种", prop: "patient_data.tumour" },
        { label: "状态", prop: "status", formatter: showStatus },
        // {
        //   label: "跟进情况",
        //   prop: "task_data.visit_result",
        //   formatter: showVisitResult,
        // },
        { label: "留言时间", prop: "create_time" },
      ],
    };
  },
  methods: {
    ...mapMutations("illuserData", ["setMessageRow"]),
    goToAudit(row) {
      let ids = [];
      // this.tableData.forEach(v => {
      //     ids.push(v.task_data.task_id)
      // });
      let params = {
        list: this.tableData,
        row: row,
      };
      this.setMessageRow(params);
      this.$emit("changeTopTab", "editView");
    },
    handleCurrentChange(val) {
      this.getTableData(val);
    },
    getTableData(v = 1) {
      let params = {
        page: v,
        page_size: this.pageSize,
        is_finish: this.searchForm.status,
      };
      // console.log(params, '69');
      this.httpPost("/vipmessage/list", params).then((res) => {
        this.tableData = res.data.data_list;
        this.total = res.data.total;
        this.$nextTick(() => {
          this.currentPage = v;
        });
      });
    },
  },
  activated() {
    this.$nextTick(() => {
      this.$refs.table.doLayout(); //解决表格错位
      this.getTableData();
    });
  },
  mounted() {
    this.getTableData();
    this.$nextTick(() => {
      this.tableHeight =
        this.$refs.common_table_view.clientHeight -
        this.$refs.header.clientHeight -
        this.$refs.bottom_page.clientHeight;
    });
  },
};
</script>
<style lang="scss" scoped>
</style>